import { getEnv } from "@/env";

export function checkPersonalizationFlag(): boolean {
  const flagValue =
    getEnv("NEXT_PUBLIC_FEATURE_PERSONALIZED_RESULTS") || "false";
  const isPersonalizedResults: boolean = flagValue === "true";
  return isPersonalizedResults;
}
